export default "__VITE_ASSET__86c13a87__"